import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClientService } from './common/http-client.service';
import { ApiResponse, RidesListQueryParams } from './api/api.types';
import { addQueryParams } from './utils/helpers';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private https: HttpClientService) {}
  email: string = '';
  sideNavStateChanged = new Subject();
  getCustomerdata<T = any>(queryParams?: any): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/admin/listConsumers', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  getRidesListData<T = any>(
    queryParams?: RidesListQueryParams
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/admin/allRide', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  filterRides(
    rideDate: any,
    paymentMethod: any,
    currentStatus: any,
    paymentStatus: string
  ) {
    return this.https.get(
      `v1/admin/filterRides?rideDate=${rideDate}&paymentMethod=${paymentMethod}&currentStatus=${currentStatus}&paymentStatus=${paymentStatus}`,
      'bearer'
    );
  }

  postdata(data: any) {
    return this.https.post('v1/consumer/register', 'bearer', data);
  }
  updatestatus(id: any, data: any) {
    return this.https.put(
      `v1/admin/changeStatusToBlockedOrUnblocked?consumerId=${id}&isBlocked=${data}`,
      'bearer'
    );
  }
  editsubadmin(id: any, data: any) {
    return this.https.put(
      `v1/admin/editSubAdmin?subAdminId=${id}`,
      'bearer',
      data
    );
  }
  updatestatusadmin(id: any, data: any) {
    return this.https.put(
      `v1/admin/changeStatusToBlockedOrUnblockedSubadmin?adminId=${id}&isBlocked=${data}`,
      'bearer'
    );
  }
  individiualcustomer(id: any) {
    return this.https.get(
      `v1/admin/getIndividualConsumerDetails?consumerId=${id}`,
      'bearer'
    );
  }
  viewallride(id: any) {
    return this.https.get(
      `v1/admin/allRideForConsumer?consumerId=${id}`,
      'bearer'
    );
  }
  // DRIVER API
  getdriverlist<T = any>(
    queryParams?: Record<string, any>
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/admin/listDrivers', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  deleteDriver(id: any) {
    return this.https.delete(`v1/admin/deleteDriver?driverId=${id}`, 'bearer');
  }
  createDriver<T = any>(data: any): Observable<ApiResponse<T>> {
    return this.https.post(`v1/admin/createDriver`, 'bearer', data);
  }
  editCustomer(data: any, id: any) {
    return this.https.put(
      `v1/admin/editConsumers?ConsumerId=${id}`,
      'bearer',
      data
    );
  }

  editdriver<T = any>(data: any, id: string): Observable<ApiResponse<T>> {
    return this.https.put(
      `v1/admin/editDrivers?DriverId=${id} `,
      'bearer',
      data
    );
  }

  deletePost(id: any) {
    return this.https.delete(
      `v1/admin/deleteConsumers?ConsumerId=${id}`,
      'bearer'
    );
  }
  public uploadImage<T = any>(image: File): Observable<ApiResponse<T>> {
    const formData = new FormData();
    formData.append('image', image);

    return this.https.uploadFile(
      `v1/Image/Settings/uploadImage`,
      'bearer',
      formData
    );
  }
  addrate(type: any, data: any) {
    return this.https.post(
      `v1/Charges/RateType?vehicleId=${type}`,
      'bearer',
      data
    );
  }
  addbasecharge(id: any, data: any) {
    return this.https.post(
      `v1/Charges/addBaseCharges?vehicleId=${id}`,
      'bearer',
      data
    );
  }
  addvehicletype(type: any) {
    return this.https.post(
      `v1/Charges/addVehicle?vehicleType=${type}`,
      'bearer'
    );
  }
  Addsurcharge(Vid: any, region: any, data) {
    return this.https.post(
      `v1/Charges/addSurgeCharges?vehicleId=${Vid}&region=${region}
        `,
      'bearer',
      data
    );
  }
  getvehicle1() {
    return this.https.get('v1/Charges/getVehicle', 'bearer');
  }
  getridedetails(page: any) {
    return this.https.get(`v1/admin/listRides`, 'bearer');
  }
  getcancelreason<T = any>(
    queryParams?: Record<string, string | number>
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/ride/getCancelReason', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  reasoncreate(data: any, data1: any) {
    return this.https.post(
      `v1/admin/createCancelReason?reasonDrivedBy=${data}`,
      'bearer',
      data1
    );
  }
  deletereason(id: any) {
    return this.https.delete(
      `v1/admin/deleteCancelReasonFromList?cancelReasonsId=${id}`,
      'bearer'
    );
  }
  dltride(id: any) {
    return this.https.delete(`v1/admin/deleteRide?rideId=${id}`, 'bearer');
  }

  signIn(data: any) {
    return this.https.post(`v1/admin/login`, 'bearer', data);
  }
  // subadmin
  getsubadmin<T = any>(
    queryParams?: Record<string, string | number>
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/admin/listSubAdmins', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  createadmin(data: any) {
    return this.https.post(`v1/admin/createSubAdmin`, 'bearer', data);
  }

  dltadmin(id: any) {
    return this.https.delete(`v1/admin/deleteSubAdmin?adminId=${id}`, 'bearer');
  }

  editadmin(id: any, data: any) {
    return this.https.put(
      `v1/admin/editSubAdmin?subAdminId=${id}`,
      'bearer',
      data
    );
  }

  create(data: any) {
    return this.https.post(`v1/admin/createRegion`, 'bearer', data);
  }

  polygonlist() {
    return this.https.get(`v1/admin/listRegion?page=1`, 'bearer');
  }

  dashboard() {
    return this.https.get(`v1/admin/taxiOverview`, 'bearer');
  }

  dltgeofence(id: any) {
    return this.https.delete(`v1/admin/deleteRegion?regionId=${id}`, 'bearer');
  }

  getvehicle() {
    return this.https.get(`v1/admin/getVehicleList`, 'bearer');
  }

  dltvec(id: any) {
    return this.https.delete(
      `v1/Vehicles/deleteVehicles?vehicleId=${id}`,
      'bearer'
    );
  }
  editvehicle(data: any, id: any) {
    return this.https.put(
      `v1/Vehicles/updateVehicles?vehicleId=${id}`,
      'bearer',
      data
    );
  }
  getPieChartData() {
    return this.https.get(`v1/dashBoard/pieChartForRides`, 'bearer');
  }
  getTotalRevenue(options) {
    return this.https.get(
      `v1/dashBoard/totalRevenue?revenueType=${options}`,
      'bearer'
    );
  }

  forgotPassword(data: any) {
    return this.https.put(`v1/admin/forgotPassword`, 'bearer', data);
  }

  verifyOtp(data: any) {
    return this.https.put('v1/admin/verifyOtp', 'bearer', data);
  }
  resetPassword(data: any) {
    return this.https.put('v1/admin/resetPassword', 'bearer', data);
  }
  resendOtp(data: any) {
    return this.https.post('v1/admin/resendOtp', 'bearer', data);
  }
  // notification
  notificationsend(userType: any, data: any) {
    return this.https.post(
      `v1/admin/sendMultipleNotification?userType=${userType}`,
      'bearer',
      data
    );
  }
  getnotification(queryParams?: any) {
    const requestURL = addQueryParams("v1/admin/listMultipleNotification", queryParams)
    return this.https.get(requestURL, 'bearer');
  }
  getcoupon(queryParams?: any) {
    const requestURL = addQueryParams("v1/CouponCode/getCouponCodeList", queryParams)
    return this.https.get(requestURL, 'bearer');
  }
  editcoupon(data: any) {
    return this.https.put(`v1/CouponCode/updateCouponCode`, `bearer`, data);
  }
  Help(queryParams?: Record<string, string | number>) {
    const requestURL = addQueryParams('v1/ride/getRaisedIssue', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  createcoupon(data: any) {
    return this.https.post(`v1/CouponCode/createCouponCode`, 'bearer', data);
  }
  deletecouponcode(id: any) {
    return this.https.delete(
      `v1/CouponCode/deleteCouponCode?CouponCodeId=${id}`,
      'bearer'
    );
  }
  gettopdriver() {
    return this.https.get('v1/dashBoard/topDriverList', 'bearer');
  }
  gettopcustomer() {
    return this.https.get('v1/dashBoard/topConsumerList', 'bearer');
  }
  blockdriver(id: any, data: any) {
    return this.https.put(
      `v1/admin/changeStatusToBlockedOrUnblockedDriver?driverId=${id}&isBlocked=${data}`,
      'bearer'
    );
  }
  createVehicle(data: any) {
    return this.https.post(
      `v1/VehicleType/createVehicleType`,
      'bearer',
      data
    );
  }
  getvehicletype<T = any>(
    queryParams?: Record<string, string | number>
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/VehicleType/list', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
  getactiveconsumer(data: any) {
    return this.https.get(
      `v1/dashBoard/activeConsumer?filter=${data}`,
      'bearer'
    );
  }
  getactivedriver(data: any) {
    return this.https.get(
      `v1/dashBoard/activeDrivers?filter=${data}`,
      'bearer'
    );
  }

  changeSideNavState(): void {
    this.sideNavStateChanged.next(true);
  }
  createpolygon(data: any) {
    return this.https.post(`v1/geofence/createGeofence`, 'bearer', data);
  }
  editpolygon(id: any, data: any) {
    return this.https.put(
      `v1/geofence/editGeofence?geofenceId=${id}`,
      'bearer',
      data
    );
  }

  filter(date: any, type: any, module: any) {
    return this.https.get(
      `v1/admin/dateBasedRecord?date=${date}&module=${type}&dateType=${module}`,
      'bearer'
    );
  }
  getridetype() {
    return this.https.get(`v1/RideType/getListRideType`, 'bearer');
  }
  createridetype(data: any) {
    return this.https.post(`v1/RideType/createRideType`, 'bearer', data);
  }
  createPromotionalBanner(data: any) {
    return this.https.post(`v1/Banner/createBanner`, 'bearer', data);
  }
  Deleteride(id: any) {
    return this.https.delete(
      `v1/RideType/deleteRideType?rideTypeId=${id}`,
      'bearer'
    );
  }
  Deleteride1(id: any) {
    return this.https.delete(
      `v1/VehicleType/delete?vehicleTypeId=${id}`,
      'bearer'
    );
  }
  blockUnblockVehicle(id: any, data: any) {
    return this.https.put(
      `v1/VehicleType/block?vehicleTypeId=${id}&isBlocked=${data}`,
      'bearer'
    );
  }
  blockUnblockride(id: any, data: any) {
    return this.https.put(
      `v1/RideType/blockedandunblocked?rideTypeId=${id}&isBlocked=${data}`,
      'bearer'
    );
  }
  editride1(id: any, data: any) {
    return this.https.put(
      `v1/RideType/updateRideType?rideTypeId=${id}`,
      'bearer',
      data
    );
  }
  editvehicle2(id: any, data: any) {
    return this.https.put(
      `v1/VehicleType?vehicleTypeId=${id}`,
      'bearer',
      data
    );
  }
  getgeofence<T = any>(queryParams?: any): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/geofence/listGeofences', queryParams);
    return this.https.get(requestURL, 'bearer');
  }

  dltgeofenceing(id: any) {
    return this.https.delete(
      `v1/geofence/deleteGeofence?geofenceId=${id}`,
      'bearer'
    );
  }

  createPromotion<T = any>(data: any): Observable<ApiResponse<T>> {
    return this.https.post('v1/Banner', 'bearer', data);
  }

  deletePromotion<T = any>(bannerId: string): Observable<ApiResponse<T>> {
    return this.https.delete(`v1/Banner?bannerId=${bannerId}`, 'bearer');
  }

  getPromotions<T = any>(params?: any): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/Banner/listBanner', params);
    return this.https.get(requestURL, 'bearer');
  }

  editPromotion<T = any>(
    bannerId: string,
    data: any
  ): Observable<ApiResponse<T>> {
    return this.https.put(`v1/Banner?bannerId=${bannerId}`, 'bearer', data);
  }

  getSettlements<T = any>(params?: any): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/admin/settlements', params)
    return this.https.get(requestURL, 'bearer');
  }

  triggerManualSettlement<T = any>(data: any): Observable<ApiResponse<T>> {
    return this.https.post(
      'v1/admin/driver/manual/settlement',
      'bearer',
      data
    );
  }

  getRentalVehicleRequests<T = any>(
    queryParams?: Record<string, string | number>
  ): Observable<ApiResponse<T>> {
    const requestURL = addQueryParams('v1/vehicleRequests', queryParams);
    return this.https.get(requestURL, 'bearer');
  }
}
